var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 12q1.6875-.0312 2.8438-1.1562Q15.9688 9.6875 16 8q-.0312-1.6876-1.1562-2.8437Q13.6875 4.0313 12 4q-1.6876.0313-2.8437 1.1563Q8.0313 6.3125 8 8q.0312 1.6875 1.1563 2.8438Q10.3125 11.9688 12 12m1.5938 1.5h-3.1876q-2.2812.0625-3.8124 1.5938Q5.0625 16.625 5 18.9062q0 .4689.3125.7813T6.0938 20h11.8124q.4689 0 .7813-.3125T19 18.9062q-.0625-2.2812-1.5938-3.8124-1.5312-1.5313-3.8124-1.5938"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-icon.36cb53b936a3eede44579f331692b72a.svg";